import { PortfolioAllocation, PortfolioAllocationDataPoint } from '@models';
import { sortPortfolioDataPoints } from '@products/portfolio/portfolio.utils';
import {
  PortfolioMarketCapitalisationDTO,
  PortfolioDTO,
  PortfolioComponentId,
} from '@types';
import { formatPercentage } from '@utils/text/number-utils';
import { MapperFactory } from '../mapper-factory';
import { getFirstNonEmptyProp, parseStdNumber, parseYN } from '../mapper.utils';
import { Mapper, MapperParams } from '../type.mapper';

/**
 * example fund:
 * https://en-us.staging.ftsites.com/investments/options/mutual-funds/products/4402/A/franklin-biotechnology-discovery-fund/FBDIX#portfolio
 */
export class MarketCapitalisationMapper extends Mapper<PortfolioAllocation[]> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(portfolioDto: PortfolioDTO): PortfolioAllocation[] {
    const data: PortfolioMarketCapitalisationDTO[] =
      portfolioDto.marketcapallocation;

    // if no data, return null
    if (!data || data.length === 0) {
      return null;
    }
    const allocation: PortfolioAllocation = {
      componentId: PortfolioComponentId.MARKET_CAPITALISATION,
      baseLabelKey: 'market-capitalisation-breakdown',
      allocationFlag: getFirstNonEmptyProp(data, 'allocflag'),
      allocationHeading: getFirstNonEmptyProp(data, 'allocheadinglocal'),
      asOfDate: getFirstNonEmptyProp(data, 'asofdate'),
      calculationBasis: getFirstNonEmptyProp(data, 'calcbasislocal'),
      calculationType: getFirstNonEmptyProp(data, 'calcname'),
      hasDerivatives: parseYN(getFirstNonEmptyProp(data, 'hasderivatives')),
      updateFrequency: getFirstNonEmptyProp(data, 'frequency'),
      benchmarkName: getFirstNonEmptyProp(data, 'bmname'),
      data: data.sort(sortPortfolioDataPoints).map(
        (
          obj: PortfolioMarketCapitalisationDTO
        ): PortfolioAllocationDataPoint => ({
          label: obj.rangedesc,
          benchmark: formatPercentage(obj.bmbrkdwnpct),
          benchmarkStd: parseStdNumber(obj.bmbrkdwnpctstd),
          breakdown: formatPercentage(obj.brkdwnpct),
          breakdownStd: parseStdNumber(obj.brkdwnpctstd),
        })
      ),
    };
    return [allocation];
  }
}
